export default __webpack_public_path__ + "static/media/dashboard.15293543.png";